module.exports = __webpack_public_path__ + "media/images/riders/small/ADAM_BRAYTON-2c4c9a08d1fd5756d86a88a1de70f35c.png";